import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadDesignSystem } from './ds';
import { RouterProvider } from './router';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

const root = createRoot(container);

// The design system bundle registers its components on a global and every page
// renders them, so mounting before it resolves would throw. Waiting here keeps
// every component free of load-state checks.
loadDesignSystem()
  .then(() => {
    root.render(
      <React.StrictMode>
        <RouterProvider>
          <App />
        </RouterProvider>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error(err);
    root.render(
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: 40,
          // The app's own window with one message in it, so the app ground.
          background: 'var(--app-ground)',
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center'
        }}
      >
        <div>
          <h1 style={{ fontFamily: "'Baloo 2', sans-serif", fontSize: 28 }}>
            Something did not load.
          </h1>
          <p style={{ color: 'var(--text-muted)', maxWidth: 440 }}>
            The design system bundle could not be fetched. Reload the page, and if it keeps
            happening the deployment is missing <code>/_ds/mauvely/_ds_bundle.js</code>.
          </p>
        </div>
      </div>
    );
  });
